/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Blue_Deer_RestInputs */

const en_calm_blue_deer_rest = /** @type {(inputs: Calm_Blue_Deer_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment-specific min answers`)
};

const de_calm_blue_deer_rest = /** @type {(inputs: Calm_Blue_Deer_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentspezifische Mindestantworten`)
};

/**
* | output |
* | --- |
* | "Segment-specific min answers" |
*
* @param {Calm_Blue_Deer_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_blue_deer_rest = /** @type {((inputs?: Calm_Blue_Deer_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Blue_Deer_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_blue_deer_rest(inputs)
	return de_calm_blue_deer_rest(inputs)
});